/* eslint-disable */

import {
  ready,
  getMainAccount,
  getWeixinUserInfo,
  post
} from "../kbApp/kbJsBridgePromise";
import { detector } from '../util/Detect.js'
import jsapi from '../qb/jsapi';
import qbDebugJson from '../qb/debug'
function getPromise() {
  let rtResolve,
    rtReject,
    rtPromise = new Promise((resolve, reject) => {
      rtResolve = resolve;
      rtReject = reject;
    });
  return {
    rtResolve,
    rtReject,
    rtPromise
  };
}

//获取快报主登录态&&获取用户信息
const getAppMainAccount = () => {
  if (detector.app.kuaibao) {
    return new Promise((resolve, reject) => {
      ready().then(() => {
        getMainAccount().then(res => {
          if (res) {
            res = res.toLowerCase();
            if (res === "wx") {
              getWeixinUserInfo().then(res => {
                if (res) {
                  const params = {
                    name: res.nick,
                    avatar: res.head_url
                  };

                  if (!/^oI6CFj/.test(res.openid)) {
                    post(
                      "https://kuaibao.qq.com/h/wf/uploadUserInfo",
                      params
                    ); //上传微信用户信息
                  }
                }
                resolve({
                  isLogin: true,
                  mainAccount: "wx",
                  userInfo: {
                    nick: res.nick,
                    avatar: res.head_url,
                    userId: res.openid
                  }
                });
              });
            } else if (res === "qq") {
              post("https://kuaibao.qq.com/h/wf/getUserInfo").then(
                res => {
                  if (res && res.ret == 0 && res.data) {
                    resolve({
                      isLogin: true,
                      mainAccount: "qq",
                      userInfo: {
                        nick: res.data.name,
                        avatar: res.data.avatar,
                        userId: res.data.uin
                      }
                    });
                  } else {
                    resolve({
                      isLogin: true,
                      mainAccount: "qq"
                    });
                  }
                }
              );
            } else if (res === "unknown") {
              resolve({
                isLogin: false,
                mainAccount: "unknown"
              });
            } else {
              resolve({
                isLogin: true,
                mainAccount: "other"
              })
            }
          } else {
            reject("get main account fail");
          }
        });
      })
    })
  } else if (detector.app.qb) {
    const { rtResolve, rtReject, rtPromise } = getPromise();
    let mainAccount = '';
    let userInfo = {};
    if (window.browser && window.browser.login && window.browser.login.getAccountInfo) {
      console.log('getAccountInfo start');
      window.browser.login.getAccountInfo((rst) => {
        console.log('getUserInfo rst', rst);
        if (!/html5.qq.com/.test(location.href) && qbDebugJson.isDebug) {
          rst = qbDebugJson.debugUserInfo;
        }

        if (rst && rst.qbid) {
          userInfo = {
            qbid: rst.qbid,
            type: rst.type,
            uin: rst.uin,
            skey: rst.skey,
            token: rst.token,
            appid: rst.appid,
            avatar: rst.head,
            nickname: rst.nickname,
            userId: rst.uin,
            isLogin: 1
          };

          const { type } = rst;
          switch (Number(type)) {
            case 1:
              mainAccount = 'qq';
              break;
            case 2:
              mainAccount = 'wx';
              break;
            case 4:
              mainAccount = 'qqunion';
              break;
            case 6:
              mainAccount = 'phone';
              break;
            default:
              mainAccount = 'other';
              break;
          }
          // 注册push
          jsapi.QBPushRegister(userInfo.qbid);

          rtResolve({
            isLogin: true,
            mainAccount,
            userInfo
          });
        } else {
          console.log('getUserInfo qbid not exist');
          rtResolve({
            isLogin: false,
            mainAccount: "unknown",
            userInfo
          });;
        }
      }, (err) => {
        console.log('获取qbid错误error:', err);
        rtReject(err);
      }, { appID: '116' });
    } else {
      console.log('getAccountInfo undefined');
      rtReject(null);
    }

    return rtPromise;
  }

};

//检测是否已登录
const checkLogin = () => {
  return new Promise(function (resolve, reject) {
    if (detector.app.kuaibao) {
      getMainAccount().then(res => {
        if (res) {
          res = res.toLowerCase();
          if (res === "wx" || res === "qq" || res === "phone") {
            resolve(true);
          } else if (res === "unknown") {
            resolve(false);
          }
        } else {
          reject("check login fail");
        }
      });
    } else if (detector.app.qb) {
      getAppMainAccount().then(res => {
        if (res) {
          if (res.isLogin) {
            return resolve(true);
          } else {
            return resolve(false);
          }
        } else {
          console.log("check login fail");
          return resolve(false);
        }
      })
    }

  });
};

export { getAppMainAccount, checkLogin };
